(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comfy-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.csInit === 'true') return;
    root.dataset.csInit = 'true';

    // ==============================
    // ELEMENTS
    // ==============================
    var gallery = root.querySelector('[data-cs-imgs]');
    var imgs = Array.from(
      root.querySelectorAll('[data-cs-imgs] img')
    );
    var thumbs = Array.from(
      root.querySelectorAll('[data-cs-thumb]')
    );
    var swatches = Array.from(
      root.querySelectorAll('[data-cs-swatch]')
    );

    var idInput = root.querySelector('[data-cs-variant-id]');
    var priceEl = root.querySelector('[data-cs-price]');
    var addBtn = root.querySelector('[data-cs-add]');
    var addLabel = root.querySelector('[data-cs-add-label]');
    var jsonEl = root.querySelector('[data-cs-variants]');
    var form = root.querySelector('[data-cs-form]');

    var variants = [];

    try {
      variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]');
    } catch (error) {
      console.error('Comfy Hero: Invalid variants JSON.', error);
    }

    var addText = root.dataset.csAddText ||
      (addLabel ? addLabel.textContent.trim() : 'Add to cart');

    var soldOutText = root.dataset.csSoldOutText || 'Sold out';
    var activeVariant = null;

    if (!gallery || !imgs.length) {
      console.warn('Comfy Hero: Gallery or images not found.');
      return;
    }

    // ==============================
    // NORMALIZE VALUES
    // ==============================
    function normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ');
    }

    // ==============================
    // IMAGE / THUMBNAIL HELPERS
    // ==============================
    function getImageKey(img) {
      return normalize(img.dataset.colorKey);
    }

    function showImage(image) {
      if (!image || image.style.display === 'none') return;

      imgs.forEach(function (img) {
        img.classList.toggle('is-on', img === image);
      });

      thumbs.forEach(function (thumb) {
        var index = Number(thumb.dataset.imageIndex);
        var matchingImage = imgs[index];

        thumb.setAttribute(
          'aria-pressed',
          String(matchingImage === image)
        );
      });
    }

    // Show only images belonging to the selected color.
    function updateGallery(colorKey) {
      var key = normalize(colorKey);

      var matchingImages = imgs.filter(function (img) {
        return getImageKey(img) === key;
      });

      // If no image matches the selected color,
      // use default/olive images.
      if (!matchingImages.length) {
        matchingImages = imgs.filter(function (img) {
          return getImageKey(img) === 'olive' ||
            getImageKey(img) === 'default';
        });
      }

      // For galleries using Shopify product images.
      if (!matchingImages.length) {
        matchingImages = imgs.filter(function (img) {
          return getImageKey(img) === 'all' ||
            getImageKey(img) === '';
        });
      }

      // Final fallback.
      if (!matchingImages.length) {
        matchingImages = imgs.slice(0, 1);
      }

      imgs.forEach(function (img) {
        var visible = matchingImages.indexOf(img) !== -1;

        img.style.display = visible ? '' : 'none';
        img.classList.remove('is-on');
      });

      thumbs.forEach(function (thumb) {
        var index = Number(thumb.dataset.imageIndex);
        var image = imgs[index];

        var visible = image &&
          matchingImages.indexOf(image) !== -1;

        thumb.style.display = visible ? '' : 'none';
        thumb.setAttribute('aria-pressed', 'false');
      });

      // Activate the first image of the selected color.
      showImage(matchingImages[0]);
    }

    // ==============================
    // VARIANT MATCHING
    // ==============================
    function findVariant(button) {
      var value = button.dataset.optionValue;

      var position = parseInt(
        button.dataset.optionPosition || '1',
        10
      ) - 1;

      if (!value || position < 0) return null;

      return variants.find(function (variant) {
        return variant.options &&
          normalize(variant.options[position]) === normalize(value);
      }) || null;
    }

    // ==============================
    // UPDATE PRICE / STOCK / VARIANT
    // ==============================
    function updateVariant(button) {
      var variant = findVariant(button);

      if (!variant) {
        console.warn(
          'Comfy Hero: Variant not found for option value:',
          button.dataset.optionValue
        );
        return;
      }

      activeVariant = variant;

      if (idInput) {
        idInput.value = variant.id;
      }

      if (priceEl) {
        priceEl.textContent = variant.price;
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
      }

      if (addLabel) {
        addLabel.textContent = variant.available
          ? addText
          : soldOutText;
      }

      // Update selected variant in the URL.
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);

        window.history.replaceState({}, '', url);
      } catch (error) {
        console.warn('Comfy Hero: Could not update variant URL.', error);
      }
    }

    // ==============================
    // SELECT COLOR SWATCH
    // ==============================
    function selectSwatch(button) {
      if (!button) return;

      // IMPORTANT:
      // Image key is olive/beige.
      // Shopify option value may be Arabic.
      var colorKey = button.dataset.colorKey ||
        button.dataset.optionValue;

      swatches.forEach(function (swatch) {
        swatch.setAttribute(
          'aria-pressed',
          String(swatch === button)
        );
      });

      // Change the gallery image first.
      updateGallery(colorKey);

      // Update the actual Shopify variant.
      updateVariant(button);
    }

    swatches.forEach(function (button) {
      button.addEventListener('click', function () {
        selectSwatch(button);
      });
    });

    // ==============================
    // THUMBNAIL CLICK
    // ==============================
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.dataset.imageIndex);
        var image = imgs[index];

        showImage(image);
      });
    });

    // ==============================
    // AJAX ADD TO CART
    // ==============================
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (
          !addBtn ||
          addBtn.disabled ||
          !idInput ||
          !idInput.value
        ) {
          return;
        }

        var originalDisabled = addBtn.disabled;
        addBtn.disabled = true;

        var baseUrl =
          (window.Shopify &&
            Shopify.routes &&
            Shopify.routes.root) || '/';

        fetch(baseUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            return fetch(baseUrl + 'cart.js');
          })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Unable to retrieve cart.');
            }

            return response.json();
          })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', {
                detail: { cart: cart }
              })
            );

            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: { cart: cart }
              })
            );

            document.querySelectorAll(
              '[data-cart-count], .cart-count, .cart-count-bubble span'
            ).forEach(function (element) {
              element.textContent = cart.item_count;
            });

            var drawer = document.querySelector(
              'cart-drawer, #cart-drawer, [data-cart-drawer]'
            );

            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              window.location.href = baseUrl + 'cart';
            }
          })
          .catch(function (error) {
            alert(
              error.description ||
              error.message ||
              'Unable to add product to cart.'
            );
          })
          .finally(function () {
            addBtn.disabled = !activeVariant ||
              !activeVariant.available;
          });
      });
    }

    // ==============================
    // INITIAL SELECTED VARIANT
    // ==============================
    var initialVariant = variants.find(function (variant) {
      return idInput &&
        String(variant.id) === String(idInput.value);
    });

    var initialSwatch = null;

    if (initialVariant) {
      initialSwatch = swatches.find(function (button) {
        var variant = findVariant(button);

        return variant &&
          String(variant.id) === String(initialVariant.id);
      });
    }

    // If the current variant has no matching swatch,
    // choose the first configured swatch.
    initialSwatch = initialSwatch || swatches[0];

    if (initialSwatch) {
      selectSwatch(initialSwatch);
    } else {
      showImage(
        imgs.find(function (img) {
          return img.classList.contains('is-on');
        }) || imgs[0]
      );
    }
  }

  // ==============================
  // INITIALIZE ALL HERO SECTIONS
  // ==============================
  function initAll() {
    document.querySelectorAll('[data-cs-hero]').forEach(initHero);
  }

  initAll();

  // Shopify Theme Editor section reload support.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (
      section.matches &&
      section.matches('[data-cs-hero]')
    ) {
      initHero(section);
    } else {
      initAll();
    }
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
